import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/chayanrastogi'
      className='link footer__link'
      target='blank'
    >
      Created By Chayan Rastogi
    </a>
  </footer>
)

export default Footer
